<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 面会者（家族）の登録状態
      .right-side
        slot(name="question")

    .register-value.reservation-use-family-radios
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          name="use-family"
          type="radio"
          :value="false"
          v-validate="{ required: true }"
          data-vv-as="面会者（家族）の登録状態")
        span.register-radio-text 未登録
      label.register-radio-label(v-show="showRegisterd")
        input#type-2.register-radio-form(v-model="_value" name="use-family" type="radio" :value="true")
        span.register-radio-text 登録済

    .error-messages(v-for="error in errors.collect('use-family')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputReservationUseFamily extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Boolean })
  value!: boolean;

  /** 登録済みを表示するか否か */
  @Prop({ type: Boolean })
  showRegisterd!: boolean;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): boolean {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.reservation-type-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}
// ラジオボタンが2つしかないのでラップされることはありえないのでマージン調整
.register-radio-label {
  margin: 0 8px 0 0 !important;
}
</style>
